import { getVariant, makeStyledComponent } from '@apia/theme';
import React from 'react';
import { Spinner } from '@apia/theme';
import { ThemeUICSSObject } from '@apia/theme';

export const styles: ThemeUICSSObject = {
  height: 'iconmd',
  width: 'iconmd',
  background: 'palette.background.paper',
};

const LoaderSpinner = makeStyledComponent(
  'LoaderSpinner',
  'layout.common.components.loaderSpinner',
  styles,
  ({ className }: { className?: string }) => {
    return (
      <Spinner
        {...getVariant('layout.common.components.loaderSpinner')}
        className={className}
      />
    );
  },
);

export default LoaderSpinner;
